export {
  Context as GeneralContext,
  Provider as GeneralContextProvider,
  Consumer as GeneralContextConsumer,
} from './general';
